import { Record } from '../editor/record.types';

export const linkParentRecord = (parentRecord: Record<any> | null | undefined, record: Record<any> | null) => {
  const currentParentRecord = { ...parentRecord };
  if (record?.id && currentParentRecord) {
    if (currentParentRecord.to) {
      currentParentRecord.to.push({ formId: record.form_id || '', recordId: record.id, title: 'task' });
    } else {
      currentParentRecord.to = [{ formId: record.form_id || '', recordId: record.id, title: 'task' }];
    }
    // @ts-ignore
    let linkedRecord = currentParentRecord.form_values.ccc1;
    if (linkedRecord && linkedRecord.length) {
      linkedRecord.push({ record_id: record.id });
    } else {
      linkedRecord = [{ record_id: record.id }];
    }
    // @ts-ignore
    currentParentRecord.form_values.ccc1 = linkedRecord;
  }

  return currentParentRecord;
};
